export default __webpack_public_path__ + "static/media/honda.23712bbd.png";